import { createAction, props } from '@ngrx/store';

import { RequestStatus } from 'src/app/resources/common/request';
import {
  AuthInfo,
  SignInRequest,
  SignInWithSecretRequest,
  SignInWitOtpRequest,
  VerificationCodeRequest
} from '../models';
import { AuthActionType } from './AuthActionType';



export class AuthActions {
  static readonly reset = createAction(
    AuthActionType.Reset
  );

  static readonly sendVerificationCode = createAction(
    AuthActionType.SendVerificationCode,
    props<{requestStatus: RequestStatus, authInfo: AuthInfo, request: VerificationCodeRequest, resend: boolean}>()
  );

  static readonly sendVerificationCodeFailed = createAction(
    AuthActionType.SendVerificationCodeFailed,
    props<{requestStatus: RequestStatus}>()
  );

  static readonly sendVerificationCodeFulfilled = createAction(
    AuthActionType.SendVerificationCodeFulfilled,
    props<{requestStatus: RequestStatus}>()
  );

  static readonly setVerificationMethod = createAction(
    AuthActionType.SetVerificationMethod,
    props<{verificationMethod: string}>()
  );

  static readonly signIn = createAction(
    AuthActionType.SignIn,
    props<{requestStatus: RequestStatus, authInfo: AuthInfo, request: SignInRequest}>()
  );

  static readonly signInFailed = createAction(
    AuthActionType.SignInFailed,
    props<{requestStatus: RequestStatus}>()
  );

  static readonly signInFulfilled = createAction(
    AuthActionType.SignInFulfilled,
    props<{requestStatus: RequestStatus, authInfo: AuthInfo, redirectionUrl: string}>()
  );

  static readonly verify = createAction(
    AuthActionType.Verify,
    props<{requestStatus: RequestStatus, authInfo: AuthInfo, request: SignInWitOtpRequest | SignInWithSecretRequest}>()
  );

  static readonly verificationFailed = createAction(
    AuthActionType.VerificationFailed,
    props<{requestStatus: RequestStatus}>()
  );
}
